export default __webpack_public_path__ + "static/media/video6.d4e61b39.mp4";